/* eslint-disable react/jsx-pascal-case */
import React from "react";
// import { toUpper } from "lodash";
import { Palette } from "../AppConfig";
import FilterSelect from "react-select";
// import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputBase from "@material-ui/core/InputBase";
// import { WindowsMotionController } from "babylonjs";
// import InputLabel from "@material-ui/core/InputLabel";
import { useDispatch } from "react-redux";
// import { useSelector, useDispatch } from "react-redux";
// import FormControl from "@material-ui/core/FormControl";
import BSL_ControlContainer from "./BSL_ControlContainer";
import { Tooltip } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
// import Tooltip from '@material-ui/core/Tooltip';

const BSL_Input = withStyles((theme) => ({
    root: (props) => ({
        width: props.width ? props.width : "100%",
        "label + &": {
            marginTop: theme.spacing(3),
        },
        "& img": {
            width: "32px",
            height: "12px",
            paddingRight: "2px",
        },
        "&.Mui-disabled": {
            border: "none",
        },
        border: "1px solid " + (props.children ? Palette.Control.DarkBlueTrans : Palette.Lysaght.DarkBlue),
        "&.Mui-focused": {
            border: "2px solid " + (props.children ? Palette.Control.DarkBlueTrans : Palette.Lysaght.LightBlue),
        },
        "&:hover": {
            boxShadow: "0px 0px 2px " + (props.children ? Palette.Control.DarkBlueTrans : Palette.Lysaght.LightBlue),
        },
    }),
    input: (props) => ({
        width: "100%",
        borderRadius: 2,
        textAlign: "start",
        position: "relative",
        border: "0px solid #6b8799",
        padding: "4px 26px 4px 12px",
        marginTop: theme.brand.FIELDERS ? "0px" : "2px",
        // backgroundColor: theme.palette.background.paper,
        // Use the system font instead of the default Roboto font.
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        font: theme.brand.FIELDERS
            ? "400 14px " + theme.typography.fontFamily
            : "200 14px " + theme.typography.fontFamily,
        "&:focus": {
            // borderRadius: 4,
            border: "0px solid " + (props.children ? Palette.Control.DarkBlueTrans : Palette.Lysaght.DarkBlue),
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "0px solid " + (props.children ? Palette.Control.DarkBlueTrans : Palette.Lysaght.DarkBlue),
        },
        "&.Mui-focused": {
            border: "0px solid " + (props.children ? Palette.Control.DarkBlueTrans : Palette.Lysaght.DarkBlue),
        },
    }),
}))(InputBase);

export const BSL_MenuItem = withStyles((theme) => ({
    root: {
        font: theme.brand.FIELDERS
            ? "400 14px " + theme.typography.fontFamily
            : "200 14px " + theme.typography.fontFamily,

        minHeight: "32px",
        padding: "4px 14px 4px 24px",
        "&:hover": {
            backgroundColor: Palette.Control.LightGrey,
            "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                // color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
    root: {
        textShadow: "none",
    },
    input: {
        flex: "1",
        padding: "4px 0px",
        color: Palette.Control.DarkGrey,
        font: "14px " + theme.typography.fontFamily,
    },
    input_tight: {
        padding: "2px 0px 0px 0px",
        font: "13px " + theme.typography.fontFamily,
    },
    margin: {
        margin: "2px 2px 0px 8px",
    },
    menu_paper: {
        border: "1px solid " + Palette.Control.DarkBlueTrans,
    },
    thumbnail: {
        width: "80px",
        height: "24px",
        objectFit: "contain",
        paddingRight: "10px",
    },
    disabled: {
        color: Palette.Control.Grey,
    },
}));

const FilterSelectStyles = (open) => ({
    dropdownIndicator: (base, state) => ({
        ...base,
        transition: "all .2s ease",
        transform: open ? "rotate(180deg)" : null,
        color: "#767676",
    }),
    singleValue: (provided) => ({ ...provided, color: "#666" }),
    option: (provided, state) => ({
        ...provided,
        color: "black",
        backgroundColor: state.isSelected ? "#ebebeb" : state.isDisabled ? "#f6f6f6" : "inherit",
        "&:hover": { backgroundColor: state.isSelected ? "#ebebeb" : state.isDisabled ? "#f6f6f6" : "#ebebeb" },
        textAlign: state.isDisabled ? "center" : "inherit",
    }),
    menu: (provided) => ({
        ...provided,
        marginTop: 0,
        fontSize: 12,
        borderwidth: 10,
        overflow: "hidden",
        opacity: open ? 1 : 0,
        width: open ? "100%" : "65%",
        height: open ? "300px" : "0px",
        transition: "all 0.2s ease-in-out",
        visibility: open ? "visible" : "hidden",
    }),
    control: (provided, state) => ({
        ...provided,

        border: open
            ? "2px solid " + (window.brand === "Fielders" ? Palette.Control.DarkBlueTrans : Palette.Lysaght.LightBlue)
            : "1px solid " + (window.brand === "Fielders" ? Palette.Control.DarkBlueTrans : Palette.Lysaght.DarkBlue),

        "&:hover": {
            boxShadow: open
                ? `0px 0px 0px ${
                      window.brand === "Fielders" ? Palette.Control.DarkBlueTrans : Palette.Lysaght.LightBlue
                  }`
                : `0px 0px 2px ${
                      window.brand === "Fielders" ? Palette.Control.DarkBlueTrans : Palette.Lysaght.LightBlue
                  }`,
        },

        height: "29px",
        minHeight: "29px",
        borderRadius: "0px",
        background: "#fff",
        outlineOffset: "-1px",
        marginTop: "0px",
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: "29px",
        padding: "0 6px",
    }),

    input: (provided, state) => ({
        ...provided,
        margin: "0px",
    }),
    indicatorSeparator: (state) => ({
        display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: "29px",
    }),
});

export function BSL_FilterSelect(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleOpenMenu = (value) => {
        if (!props.isDisabled) {
            setOpen(value);
        } else if (open) {
            setOpen(false);
        }
    };

    return (
        <BSL_ControlContainer {...props}>
            <Tooltip title={props.isDisabled && props.disabledTooltip ? props.disabledTooltip : ""}>
                <div onClick={() => handleOpenMenu(!open)}>
                    <FilterSelect
                        menuIsOpen
                        isSearchable={!props.isDisabled}
                        value={props.value}
                        options={props.options}
                        onChange={props.onChange}
                        className={classes.input}
                        onBlur={() => handleOpenMenu(false)}
                        styles={FilterSelectStyles(open)}
                    />
                </div>
            </Tooltip>
        </BSL_ControlContainer>
    );
}

export default function BSL_Select(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [age, setAge] = React.useState("");
    const { label, items, value, valueKey = "Key", keyKey = "Key", displayKey = "Display", inputWidth } = props;

    let menu_items = [];
    if (props.placeHolder) {
        menu_items.push(
            <MenuItem disabled value="">
                <em>{props.placeHolder}</em>
            </MenuItem>
        );
    }
    if (props.children) {
        menu_items = props.children;
    } else if (items && Array.isArray(items)) {
        for (let menuItem of items) {
            // console.log(menuItem);
            // console.log(items);
            if (typeof menuItem === "string" || typeof menuItem === "number") {
                menu_items.push(
                    <BSL_MenuItem key={menuItem} value={menuItem} disabled={menuItem.disabled}>
                        {menuItem}
                    </BSL_MenuItem>
                );
            } else if (React.isValidElement(menuItem)) {
                menu_items.push(menuItem);
            } else if (typeof menuItem === "object") {
                if (menuItem.disabled) {
                    menu_items.push(
                        <Tooltip title={menuItem.disabledTooltip ? menuItem.disabledTooltip : ""}>
                            <div
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }}
                            >
                                <BSL_MenuItem
                                    key={menuItem[keyKey]}
                                    value={menuItem[valueKey]}
                                    disabled={menuItem.disabled}
                                >
                                    {menuItem.Thumbnail ? (
                                        <img className={classes.thumbnail} src={menuItem.Thumbnail} />
                                    ) : (
                                        ""
                                    )}
                                    {menuItem[displayKey]}
                                </BSL_MenuItem>
                            </div>
                        </Tooltip>
                    );
                } else {
                    menu_items.push(
                        <BSL_MenuItem key={menuItem[keyKey]} value={menuItem[valueKey]} disabled={menuItem.disabled}>
                            {menuItem.Thumbnail ? <img className={classes.thumbnail} src={menuItem.Thumbnail} /> : ""}
                            {menuItem[displayKey]}
                        </BSL_MenuItem>
                    );
                }
            }
        }
    } else if (typeof items === "object") {
        for (let key in items) {
            menu_items.push(
                <BSL_MenuItem key={key} value={key}>
                    &nbsp;{items[key]?.name ? items[key]?.name : key}
                </BSL_MenuItem>
            );
        }
    }

    return (
        <BSL_ControlContainer {...props}>
            <Select
                displayEmpty={true}
                variant="outlined"
                disabled={props.disabled}
                onChange={props.onChange}
                id="demo-customized-select"
                value={value === undefined ? "" : value}
                labelId="demo-customized-select-label"
                MenuProps={{
                    classes: {
                        paper: classes.menu_paper,
                    },
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    style: {
                        marginTop: "5px",
                        marginLeft: "-1px",
                        border:
                            "1px solid " + window.FIEDLERS ? Palette.Control.DarkBlueTrans : Palette.Lysaght.DarkBlue,
                    },
                    getContentAnchorEl: null,
                }}
                IconComponent={KeyboardArrowDownIcon}
                input={
                    <BSL_Input FIELDERS={window.FIELDERS} width={inputWidth}>
                        {window.FIELDERS}
                    </BSL_Input>
                }
                inputProps={{
                    classes: {
                        root: classes.root,
                    },
                }}
                style={props.selectStyle ? props.selectStyle : { background: "white" }}
            >
                {menu_items}
            </Select>
        </BSL_ControlContainer>
    );
}
